import React from 'react';

const InvalidVerify = () => {
    return(
        <h1 style={{'text-align': "center"}}>This email has been already verified</h1>
    )
}

export default InvalidVerify